module.exports = __webpack_public_path__ + "static/film4-75480ad2df1f94462ea59c42e63583c7.jpg";